export type BudgetDownloadFormat = 'xlsx' | 'csv' | 'template' | 'price-template'

/** Same-origin URL of the export route; Vite proxies /download in development and the `token` cookie carries the session. */
export const costBudgetDownloadUrl = (projectId: string, format: BudgetDownloadFormat, nodeId?: string | null): string => {
  const params = new URLSearchParams({ format })
  if (nodeId && !format.endsWith('template')) params.set('nodeId', nodeId)
  return `/download/cost-budget/${encodeURIComponent(projectId)}?${params.toString()}`
}

export type ReportFormat = 'pdf' | 'xlsx'

/** The cost report (1b-C spec §6), scoped to a level-one node when given. */
export const costReportDownloadUrl = (projectId: string, format: ReportFormat, nodeId?: string | null): string => {
  const params = new URLSearchParams({ format })
  if (nodeId) params.set('nodeId', nodeId)
  return `/download/cost-report/${encodeURIComponent(projectId)}?${params.toString()}`
}

/** The protocol of a certified payment application (1b-C spec §7). */
export const costApplicationProtocolUrl = (applicationId: string): string =>
  `/download/cost-application/${encodeURIComponent(applicationId)}/protocol`
